import { Component, OnInit } from "@angular/core";
import { User } from "@angular/fire/auth";
import { AuthService } from "src/app/shared/services/auth.service";
import { Router } from "@angular/router";

@Component({
    selector: "app-email-verification",
    templateUrl: "./email-verification.component.html",
    styleUrls: ["./email-verification.component.scss"],
    standalone: false
})
export class EmailVerificationComponent implements OnInit {
  /** Instance for the current logged user's from auth service */
  protected user: User | null;

  /** Flag to show if a new message has been sent */
  protected showResendMessage: boolean = false;

  /** Flags to show or hide the loading animation */
  protected isLoading: boolean = false;

  /** Flag to show in case of error */
  protected showErrorMessage: boolean = false;

  constructor(private authService: AuthService, private router: Router) {}

  ngOnInit(): void {
    // Suscribe to user on the auth service
    this.authService.authUserChanges$.subscribe((user) => {
      this.user = user;
      // Checks if user vericates the email
      if (this.user?.emailVerified) {
        this.router.navigate(["/dashboard/default"]);
      }
    });
  }

  /**
   * Reloads the page by taking the user to the default dashboard
   * If user is alrady validated the guards will let acceso or will
   * take the user back to the verification component (Route)
   */
  reload() {
    setTimeout(() => {
      window.location.reload();
    });
  }

  /**
   * Resends the verification email for the given user
   */
  resendVerificationEmail() {
    this.showResendMessage = false;
    this.isLoading = true;
    this.showErrorMessage = false;
    this.authService
      ._sendEmailVerification()
      .then((isSent) => {
        if (isSent) {
          // The new message has been sent
          this.showResendMessage = true;
        }
      })
      .catch((error) => {
        this.showErrorMessage = true;
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
}
